import { render, staticRenderFns } from "./HistoricoLlamadas.vue?vue&type=template&id=856a7e4a&"
import script from "./HistoricoLlamadas.vue?vue&type=script&lang=js&"
export * from "./HistoricoLlamadas.vue?vue&type=script&lang=js&"
import style0 from "./HistoricoLlamadas.vue?vue&type=style&index=0&id=856a7e4a&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports